import React from 'react';
import { FormShowTemplate } from 'framework/form';
import EmployeeSkillsContent from './EmployeeSkillsContent';
import useEmployeeSkillsService from './useEmployeeSkillsService';

const EmployeeSkills = () => {
  const { getAllData, submitSkills } = useEmployeeSkillsService();

  return (
    <FormShowTemplate submitFormFunc={submitSkills} getDataFunc={getAllData} isSmallLoader>
      <EmployeeSkillsContent />
    </FormShowTemplate>
  );
};

export default EmployeeSkills;
